<template>
    <administrative>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing"/>
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <form @submit.prevent="submitForm"  enctype="multipart/form-data">
                    <div class="grid grid-cols-8 gap-4 mb-4">
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'First Name'"/>
                            <breeze-input required v-model="form.first_name" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.first_name:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Middle Name'"/>
                            <breeze-input required v-model="form.middle_name" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.middle_name:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Last Name'"/>
                            <breeze-input required v-model="form.last_name" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.last_name:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Mobile No'"/>
                            <breeze-input required type="number" v-model="form.mobile" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.mobile:''"/>
                        </div>
                        <div class="col-span-6 sm:col-span-6">
                            <breeze-label :required="true" :value="'Email Id'"/>
                            <breeze-input required type="email" v-model="form.email" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.email:''"/>
                        </div>
                        <div class="grid grid-cols-2 w-full col-span-2">
                            <div class="">
                                <breeze-label :value="'Male'"/>
                                <input-checkbox required type="radio" class="rounded-full" name="gender" :value="'male'"
                                                v-model="form.gender" :checked="form.gender == 'male'"/>
                            </div>
                            <div class="">
                                <breeze-label :value="'Female'"/>
                                <input-checkbox required type="radio" value="female" :checked="form.gender == 'female'"
                                                class="rounded-full" name="gender" v-model="form.gender"/>
                            </div>
                            <div class="col-span-2">
                                <breeze-input-error :message="form.errors?form.errors.gender:''"/>
                            </div>
                        </div>
                        <div class="col-span-8 sm:col-span-8">
                            <breeze-label :required="true" :value="'Address Line 1'"/>
                            <breeze-input required v-model="form.address_line_1" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.address_line_1:''"/>
                        </div>
                        <div class="col-span-8 sm:col-span-8">
                            <breeze-label :value="'Address Line 2'"/>
                            <breeze-input v-model="form.address_line_2" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.address_line_2:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Landmark'"/>
                            <breeze-input required  v-model="form.landmark" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.landmark:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'City'"/>
                            <breeze-input required  v-model="form.city" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.city:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'State'"/>
                            <breeze-input required  v-model="form.state" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.state:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Pincode'"/>
                            <breeze-input required  v-model="form.pincode" type="number" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.pincode:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-1">
                            <breeze-label :value="'Regular'"/>
                            <input-checkbox required type="radio" value="regular" class="rounded-full" name="type"
                                            v-model="form.type" :checked="form.type == 'regular'"/>
                            <breeze-input-error :message="form.errors?form.errors.type:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-1">
                            <breeze-label :value="'Visiting'"/>
                            <input-checkbox required type="radio" value="visiting" class="rounded-full" name="type"
                                            v-model="form.type" :checked="form.type == 'visiting'"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'Status'" />
                            <breeze-checkbox v-model="form.status"/>
                            <breeze-input-error :message="form.errors ? form.errors.status : ''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                                 <ProfileImageComponent
                                    required
                                    v-model="form.image"
                                    :error-message="form.errors?.image"/>

                        </div>
                    </div>
                    <button-link :href="route('administrative.faculty.list')" class="bg-red-500 mr-4 hover:bg-red-400">
                        Cancel
                    </button-link>
                    <breeze-button :disabled="form.processing">Save</breeze-button>
                    <exception/>
                </form>
            </div>
        </div>
    </administrative>
</template>

<script>
import Administrative from '@/Pages/Administrative/Administrative'
import BreezeTable from '@/Components/Table'
import BreezeInput from '@/Components/Input'
import BreezeLabel from '@/Components/Label'
import BreezeButton from '@/Components/Button'
import BreezeInputError from '@/Components/InputError'
import ButtonLink from '@/Components/ButtonLink'
import Exception from '@/Components/Exception'
import {useForm} from '@inertiajs/inertia-vue3'
import InputCheckbox from '@/Components/InputCheckbox'
import Loading from '@/Components/Loading'
import ProfileImageComponent from "@/Components/ProfileImageComponent.vue";
import BreezeCheckbox from '@/Components/Checkbox'

export default {
    components: {
        ProfileImageComponent,
        Administrative,
        BreezeTable,
        ButtonLink,
        BreezeInput,
        BreezeLabel,
        BreezeInputError,
        BreezeButton,
        Exception,
        InputCheckbox,
        Loading,
        BreezeCheckbox
    },
    props: ['faculty'],
    data() {
        return {
            form: useForm({
                first_name: '',
                middle_name: '',
                last_name: '',
                mobile: '',
                email: '',
                gender: '',
                address_line_1: '',
                address_line_2: '',
                landmark: '',
                city: '',
                pincode: '',
                state: '',
                type: '',
                image: '',
                status:'',
            }),
            photoPreview: ''
        }
    },
    methods: {
        submitForm() {
            if (this.$refs.photo) {
                this.form.image = this.$refs.photo.files[0]
            }
            this.form.post(route('administrative.faculty.store'), {
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
            });
        },
        selectNewPhoto() {
            this.$refs.photo.click();
        },

        deletePhoto() {
            this.photoPreview = null;
        },

        updatePhotoPreview() {
            const reader = new FileReader();

            reader.onload = (e) => {
                this.photoPreview = e.target.result;
            };

            reader.readAsDataURL(this.$refs.photo.files[0]);
        },
    },
}
</script>
